import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Page 404 - Page non trouvée
 */
const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="text-6xl font-bold text-primary-500 mb-4">404</div>
        <h1 className="text-2xl font-bold mb-4">Page non trouvée</h1>
        <p className="text-gray-600 mb-6">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        
        <div className="space-y-3">
          <Link to="/" className="block w-full bg-primary-500 text-white py-3 px-4 rounded hover:bg-primary-600 transition">
            Retour à l'accueil
          </Link>

          {/* Toutes les destinations principales (finding 1.3 : ajout Affichage/Guichet/Config ;
              « Administration » pointait vers /admin inexistant → corrigé vers /manage) */}
          <div className="grid grid-cols-2 gap-2">
            <Link to="/distributor" className="bg-secondary-500 text-white py-2 px-3 rounded hover:bg-secondary-600 transition">
              Distributeur
            </Link>
            <Link to="/display" className="bg-secondary-500 text-white py-2 px-3 rounded hover:bg-secondary-600 transition">
              Affichage
            </Link>
            <Link to="/counter" className="bg-secondary-500 text-white py-2 px-3 rounded hover:bg-secondary-600 transition">
              Guichet
            </Link>
            <Link to="/config" className="bg-gray-600 text-white py-2 px-3 rounded hover:bg-gray-700 transition">
              Config
            </Link>
            <Link to="/manage" className="col-span-2 bg-gray-600 text-white py-2 px-3 rounded hover:bg-gray-700 transition">
              Administration (Gestion)
            </Link>
          </div>

          {/* Pages d'information — servies par le serveur (@mostajs/docs-ui), hors routage React :
              des liens <a> classiques, pas des <Link>, pour une vraie navigation vers /aide et /apropos. */}
          <div className="pt-4 mt-4 border-t border-gray-200 grid grid-cols-2 gap-2">
            <a href="/aide" className="bg-blue-600 text-white py-2 px-3 rounded hover:bg-blue-700 transition">
              Aide
            </a>
            <a href="/apropos" className="bg-blue-600 text-white py-2 px-3 rounded hover:bg-blue-700 transition">
              À propos
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
